import { DiscountRule, Vendor, VendorRule } from "@finway-group/shared/lib/models"

import { CostCenter2Service, CostCenterService, ExpenseAccountService } from "Shared/services"

export type DiscountForForm = Partial<DiscountRule>
export type VendorRuleForForm = Pick<VendorRule, "costCenter" | "costCenter2" | "expenseAccount" | "paymentTerm"> & {
    discounts: Array<DiscountForForm>
    expensePaymentFlowInformation?: VendorRule["expensePaymentFlowInformation"] | ""
}

const handleEmpty = <T = string>(value?: T) => (value && value !== "" ? value : undefined)

const handleEmptyDiscount = (discount: Array<DiscountForForm>): Array<DiscountRule> => discount.filter((d) => !!d.percentage && !!d.period) as Array<DiscountRule>

export const vendorRuleSchemaToForm = (vendorRule: VendorRule): VendorRuleForForm => {
    const { discounts, ...otherRule } = vendorRule
    const discountsForForm: Array<DiscountForForm> = [...discounts]
    if (discountsForForm.length === 0) {
        discountsForForm.push({ percentage: undefined, period: undefined })
    }
    return { ...otherRule, discounts: discountsForForm }
}

export const vendorRuleFormToSchema = (formRule: VendorRuleForForm): Omit<VendorRule, "_id"> & { _id?: string } => ({
    ...formRule,
    costCenter: handleEmpty(formRule.costCenter),
    costCenter2: handleEmpty(formRule.costCenter2),
    expenseAccount: handleEmpty(formRule.expenseAccount),
    expensePaymentFlowInformation: handleEmpty(formRule.expensePaymentFlowInformation) as VendorRule["expensePaymentFlowInformation"],
    discounts: handleEmptyDiscount(formRule.discounts),
})

export const getInitialVendorRule = (vendor: Vendor | undefined): VendorRuleForForm => ({
    // Empty strings for fallback value in the forms
    costCenter: CostCenterService.getCostCenterById(vendor?.rule?.costCenter)?._id ?? "",
    costCenter2: CostCenter2Service.getCostCenter2ById(vendor?.rule?.costCenter2)?._id ?? "",
    expenseAccount: ExpenseAccountService.getExpenseAccountById(vendor?.rule?.expenseAccount)?._id ?? "",
    expensePaymentFlowInformation: vendor?.rule?.expensePaymentFlowInformation ?? "",
    paymentTerm: vendor?.rule?.paymentTerm,
    discounts: vendor?.rule?.discounts?.length ? vendor.rule.discounts : [{ period: undefined, percentage: undefined }],
})
